import loadable from "@loadable/component";
import { allDependSheets } from "../../../ssui/types/fields";
import { StrictViewType } from "./types";

const ViewRender = loadable(() => import("./render"));

export const viewTypeHkrShipGraph: StrictViewType = {
  key: "hkrShipGraph",
  displayName: "HKR-SHIP 配船表＋貯炭在庫グラフ",
  render: ViewRender as any,
  dependSheets: allDependSheets,
  configSchemas: [],
  isDisabledEditHistoryShortcuts: true,
};
